<template>
  <el-table-column
    prop="website"
    sortable
    label="Honlap"
    show-overflow-tooltip
  >
    <template slot-scope="scope">
      <el-link
        class="website-link"
        type="primary"
        :href="scope.row.website"
        target="_blank"
      >
        {{ scope.row.website }}
      </el-link>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'website',
  };
</script>

<style lang="scss">
  .website-link {
    display: inline-block;
  }
</style>
